/** Publieke site-identiteit voor meta-tags, SEO en juridische pagina's. */
export const SITE_NAME = 'Guapaa'
export const SITE_TAGLINE = 'Boek. Beheer. Groei.'
export const SITE_URL = 'https://www.guapaa.com'
export const SITE_DESCRIPTION =
  'Guapaa is een online salon-boekingsplatform: klanten boeken afspraken online, salons beheren agenda, klanten, diensten en betalingen.'
export const SITE_CONTACT_EMAIL = 'info@guapaa.com'

export function sitePageTitle (page: string): string {
  return `${page} – ${SITE_NAME}`
}
